// extracted by mini-css-extract-plugin
export var emphasizeQuantity = "_go-3";
export var flatBottomCorners = "_go-5";
export var productImage = "_go-0";
export var quantityContainer = "_go-2";
export var quantityHeader = "_go-6";
export var tooltip = "_go-1";
export var wrapAndEllipsesOverflow = "_go-4";